exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-components-Backtest-Header-___links__wrapper___3Z1YC{display:flex;justify-content:flex-end}.src-components-Backtest-Header-___links__wrapper___3Z1YC button{margin-left:10px}\n", ""]);

// Exports
exports.locals = {
	"wrapper": "src-components-Backtest-Header-___links__wrapper___3Z1YC"
};